import sendApiRequest from '../helpers/axios-setup';
import { stringify as QStringify } from 'qs';

export async function getWeeklyActionRecord(
  start_date,
  end_date,
  batch_id,
) {
  try {
    const response = await sendApiRequest.get('/weekly-action-record', {
      params: {
        start_date: start_date,
        end_date: end_date,
        batch_id: batch_id,
      }
    });
    return response.data?.data[0];
  } catch (e) {
    return null;
  }
}

export async function createWeeklyActionRecord(data) {
    const responseMap = {
    response: null,
    error: null
  };
  try {
    const response =  await sendApiRequest.post('/weekly-action-record', data);
    responseMap.response = response.data;
  } catch (error) {
    responseMap.error = error?.response?.data?.error;
  }
  return responseMap;
};

export async function updateWeeklyActionRecord(data, reportId) {
    const responseMap = {
    response: null,
    error: null
  };
  try {
    const response =  await sendApiRequest.put(`/weekly-action-record/${reportId}`, data);
    responseMap.response = response.data;
  } catch (error) {
    responseMap.error = error?.response?.data?.error;
  }
  return responseMap;
};

export async function bulkUpdateWeeklyActionRecord(data) {
  const responseMap = {
    response: null,
    error: null
  };
  try {
    const response =  await sendApiRequest.put(`/weekly-action-record/bulk/update`, data);
    responseMap.response = response.data;
  } catch (error) {
    responseMap.error = error?.response?.data?.error;
  }
  return responseMap;
};

export async function bulkCreateWeeklyActionRecord(data) {
  const responseMap = {
    response: null,
    error: null
  };
  try {
    const response =  await sendApiRequest.post('/weekly-action-record/bulk', data);
    responseMap.response = response.data;
  } catch (error) {
    responseMap.error = error?.response?.data?.error;
  }
  return responseMap;
};

